import React from 'react';
import { cn } from '@/shared/lib/cn';

interface CardProps {
  className?: string;
  children?: React.ReactNode;
}

export const Card = ({ children, className }: CardProps) => {
  return (
    <div
      className={cn(
        `
        w-full
        rounded-2xl
        border
        border-outline
        bg-background
        p-[1.25rem]
        transition-colors
        shadow-[0px_0px_30px_0px_#94A3B80D]
        `,
        className,
      )}
    >
      {children}
    </div>
  );
};
